import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, HttpModule, RequestOptions, XHRBackend } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';

// Third party
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { DragulaModule } from 'ng2-dragula';
import { ToasterModule } from 'angular2-toaster';
import { DataTableModule } from 'angular2-datatable';

// Helpers
import { AuthGuard } from './auth.guard';

// Services
import { KitService } from './services/kit.service';
import { ElementService } from './services/element.service';
import { GlobalConstantsService } from './services/global-constants.service';
import { UsersService } from './services/users.service';
import { EnginesService } from './services/engines.service';
import { SubmissionsService } from './services/submissions.service';
import { ExtendedHttpService } from './services/extended-http.service';
import { StatService } from './services/stat.service';
import { GroupsService } from './services/groups.service';

// Components
import { AppComponent } from './app.component';
import { LibraryComponent } from './components/library/library.component';
import { QueriesComponent } from './components/queries/queries.component';
import { UsersComponent } from './components/users/users.component';
import { EnginesComponent } from './components/engines/engines.component';
import { KitComponent } from './components/kit/kit.component';
import { NewFieldComponent } from './components/new-field/new-field.component';
import { ElementComponent } from './components/element/element.component';
import { GlobalConstantsComponent } from './components/global-constants/global-constants.component';
import { FieldSettingsComponent } from './components/field-settings/field-settings.component';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { StatComponent } from './components/stat/stat.component';
import { StatManagerComponent } from './components/stat-manager/stat-manager.component';
import { SubmissionFormComponent } from './components/submission-form/submission-form.component';
import { KitFolderCreateComponent } from './components/kit-folder-create/kit-folder-create.component';

// Pipes
import { SearchPipe } from './search.pipe';
import { GetByIdPipe } from './get-by-id.pipe';
import { ConstantPipe } from './constant.pipe';
import { OrderByPipe } from './order-by.pipe';
import { HiddenPipe } from './hidden.pipe';
import { GroupPipe } from './group.pipe';
import {FolderService} from './services/folder.service';
import { KitCreateComponent } from './components/kit-create/kit-create.component';
import {KitCreateResolver} from './resolvers/kit-create.resolver';
import {KitUpdateResolver} from './resolvers/kit-update.resolver';
import {LibraryResolver} from './resolvers/library.resolver';
import {ElementResolver} from './resolvers/element.resolver';
import {StylesService} from './services/styles.service';
import {FileUploadFactoryService} from './services/file-upload-factory.service';
import {KitUpdateComponent} from './components/kit-update/kit-update.component';

const appRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    children: [
      {
        path: 'library',
        component: LibraryComponent,
        resolve: {
          allKits: LibraryResolver,
        },
        canActivate: [AuthGuard],
        children: [
          { path: 'element',
            resolve: {
              elementFields: ElementResolver,
            },
            component: ElementComponent },
          { path: 'kit-create',
            resolve: {
              kitFields: KitCreateResolver,
            },
            component: KitCreateComponent },
          { path: 'kit-update/:id',
            resolve: {
              kitFields: KitUpdateResolver,
            },
            component: KitUpdateComponent },
          { path: 'kit/:id/create-folder', component: KitFolderCreateComponent },
          { path: 'global-metadata', component: GlobalConstantsComponent },
          { path: 'tags', component: StatManagerComponent }
        ]
      },
      { path: 'submissions',
        component: QueriesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'engines',
          component: EnginesComponent,
          canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: '',
    redirectTo: '/dashboard/library',
    pathMatch: 'full'
  }
];

@NgModule({
  declarations: [
    AppComponent,
    LibraryComponent,
    QueriesComponent,
    UsersComponent,
    EnginesComponent,
    KitComponent,
    NewFieldComponent,
    ElementComponent,
    SearchPipe,
    GlobalConstantsComponent,
    FieldSettingsComponent,
    GetByIdPipe,
    LoginComponent,
    DashboardComponent,
    StatComponent,
    StatManagerComponent,
    ConstantPipe,
    OrderByPipe,
    HiddenPipe,
    SubmissionFormComponent,
    GroupPipe,
    KitFolderCreateComponent,
    KitCreateComponent,
    KitUpdateComponent
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    NgbModule.forRoot(),
    BrowserModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    FileUploadModule,
    Ng2TableModule,
    DragulaModule,
    ToasterModule,
    DataTableModule
  ],
  providers: [
    FolderService,
    KitService,
    ElementService,
    GlobalConstantsService,
    AuthGuard,
    UsersService,
    EnginesService,
    SubmissionsService,
    StatService,
    GroupsService,
    KitCreateResolver,
    KitUpdateResolver,
    StylesService,
    LibraryResolver,
    ElementResolver,
    FileUploadFactoryService,
    { provide: Http, useClass: ExtendedHttpService }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts